import { render, staticRenderFns } from "./ModalDesativarMonitoramento.vue?vue&type=template&id=c0a73bec&scoped=true&lang=pug"
import script from "./ModalDesativarMonitoramento.vue?vue&type=script&lang=js"
export * from "./ModalDesativarMonitoramento.vue?vue&type=script&lang=js"
import style0 from "./ModalDesativarMonitoramento.vue?vue&type=style&index=0&id=c0a73bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a73bec",
  null
  
)

export default component.exports